<div class="p8-bdc_categories-detail__container mat-typography">
  <div class="mat-subheading-2 p8-bdc_categories-detail__heading">{{ category.data.title }}</div>
<!--  <div *ngFor="let subcategory of flatteningNodes(category.children)"-->
  <div *ngFor="let subcategory of collapseNodes(category.children)"
       [routerLink]="['/page/', subcategory.id]"
       class="p8-bdc_categories-detail__link mat-body-1"
  >{{ subcategory.data.title }}
  </div>
</div>

